import React from 'react';
import { TrendingDown } from 'lucide-react';
import { formatPrice } from './pricing';

// Best-Rate Guarantee banner. Renders nothing when the parent hasn't computed
// a savingsRange (no availability, or no positive savings vs Booking.com).
export const BestRateBanner = ({ savingsRange }) => {
  if (!savingsRange || savingsRange.max <= 0) return null;
  const { min, max } = savingsRange;
  return (
    <div
      className="max-w-4xl mx-auto mb-12 rounded-2xl overflow-hidden shadow-lg border border-emerald-200 bg-gradient-to-r from-emerald-50 via-white to-emerald-50"
      data-testid="best-rate-guarantee-banner"
    >
      <div className="flex flex-col md:flex-row items-center gap-4 p-5">
        <div className="flex-shrink-0 w-12 h-12 rounded-full bg-emerald-500 flex items-center justify-center text-white">
          <TrendingDown size={24} />
        </div>
        <div className="flex-1 text-center md:text-left">
          <div className="text-xs uppercase tracking-wider text-emerald-700 font-semibold mb-0.5">
            Best Rate Guarantee
          </div>
          <div className="text-gray-900 font-semibold">
            {min === max ? (
              <>You save <span className="text-emerald-600">{formatPrice(min)}</span> per stay by booking direct</>
            ) : (
              <>Save <span className="text-emerald-600">{formatPrice(min)}–{formatPrice(max)}</span> per stay vs Booking.com</>
            )}
          </div>
          <div className="text-xs text-gray-500 mt-0.5">
            No middlemen, no commission — direct rates only on this site
          </div>
        </div>
        <div className="hidden md:flex flex-col items-end text-xs text-gray-500 border-l pl-4">
          <div className="line-through">Booking.com</div>
          <div className="text-emerald-600 font-semibold text-base">Direct</div>
        </div>
      </div>
    </div>
  );
};
